import {
  DB_LIST_TEXTBLOCKS,
  DB_GET_TEXTBLOCK,
  TEXTBLOCKS_BY_ORG,
  TEXTBLOCKS_BY_ORG_CORR
} from "constants/ActionTypes"

const INIT_STATE = {
  db_textblocks: [],
  db_textblock: null,
  textblocks_by_org: [],
  textblocks_by_org_corr: [],
  textblocks_by_org_report: [],
  textblocks_by_org_invitation: [],
}

export default (state = INIT_STATE, action) => {
  switch(action.type) {
    case DB_LIST_TEXTBLOCKS: {
      return {
        ...state,
        db_textblocks: action.payload.db_textblocks
      }
    }

    case DB_GET_TEXTBLOCK: {
      return {
        ...state,
        db_textblock: action.payload.textblock
      }
    }

    case TEXTBLOCKS_BY_ORG: {
      return {
        ...state,
        textblocks_by_org: action.payload.textblocks
      }
    }

    case TEXTBLOCKS_BY_ORG_CORR: {
      return {
        ...state,
        textblocks_by_org_corr: action.payload.correspondence,
        textblocks_by_org_report: action.payload.report,
        textblocks_by_org_invitation: action.payload.invitation,
      }
    }

    default:
      return state;
  }
}